import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/font-awesome-flag': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M444.4 359.4C444.4 366.6 438.2 369.7 431.1 372.7 402.4 385 371.7 396.3 338.9 396.3 292.8 396.3 271.3 367.6 216 367.6 176.1 367.6 134.1 382 100.3 397.3 98.3 398.3 96.2 398.3 94.2 399.4V477.2C94.2 498.6 78 512 60.4 512 40.9 512 25.6 496.6 25.6 477.2V102.4C12.2 92.2 3 75.8 3 57.3 3 25.6 28.6 0 60.4 0S117.7 25.6 117.7 57.3C117.7 75.8 109.5 92.2 95.2 102.4V134.1C99.3 132.8 154 105.5 209.9 105.5 275.1 105.5 307.6 133.1 336.9 133.1 375.8 133.1 418.8 105.5 429 105.5 437.2 105.5 444.4 111.6 444.4 118.8V359.4z'
      }
    ]
  }
})
